import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Footer() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MANIERA Digital",
    "address": { 
      "@type": "PostalAddress", 
      "addressCountry": "RS",
      "addressLocality": "Serbia" 
    },
    "email": "info@manieradigital.com",
    "telephone": "+38163220586",
    "url": "https://www.manieradigital.com",
    "priceRange": "$$$"
  };

  return (
    <footer className="luxury-footer py-5">
      <Container>
        <Row className="text-center text-md-start">
          {/* Brand */}
          <Col md={4} className="mb-4 mb-md-0">
            <h3 className="footer-logo">MANIERA</h3>
            <p className="footer-tagline">Elegance. Precision. Identity.</p>
          </Col>

          {/* Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="footer-title">Explore</h5>
            <ul className="footer-links">
              <li><Link role="button" to="/">Home</Link></li>
              <li><Link role="button" to="/services">Services</Link></li>
              <li><Link role="button" to="/blog">Blog</Link></li>
              <li><Link role="button" to="/contact">Contact</Link></li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col md={4}>
            <h5 className="footer-title">Contact</h5>
            <p className="contact-item">Email: <a href="mailto:info@manieradigital.com">info@manieradigital.com</a></p>
            <p className="contact-item">Phone: <a href="tel:+38669663573">+386 69 663 573</a></p>
            <p className="contact-item">Serving clients worldwide</p>
          </Col>
        </Row>

        <div className="text-center mt-5 footer-bottom">
          <p>© {new Date().getFullYear()} MANIERA Digital — All Rights Reserved.</p>
        </div>
      </Container>

      {/* Pravilan način za JSON-LD u Reactu bez spoljnih biblioteka */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </footer>
  );
}